import { render, staticRenderFns } from "./settingList.vue?vue&type=template&id=baa088d8&scoped=true&"
import script from "./settingList.vue?vue&type=script&lang=ts&"
export * from "./settingList.vue?vue&type=script&lang=ts&"
import style0 from "./settingList.vue?vue&type=style&index=0&id=baa088d8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "baa088d8",
  null
  
)

export default component.exports